var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { attrs: { id: "alumniList" } },
        _vm._l(_vm.continents, function(continent, index) {
          return _c("div", { key: index }, [
            index != "Antarctica" ||
            continent["Antarctica"]["tj"].length ||
            continent["Antarctica"]["jk"].length
              ? _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "link-continent",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.showContinent(index)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "container" }, [
                        _c(
                          "h2",
                          {
                            staticClass: "heading-continent",
                            class: { open: _vm.openContinent == index }
                          },
                          [_vm._v(_vm._s(index))]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "countries-wrapper",
                      class: { open: _vm.openContinent == index }
                    },
                    _vm._l(continent, function(country) {
                      return _c(
                        "div",
                        { key: country.name },
                        [
                          country.tj.length || country.jk.length
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "country-wrapper",
                                    class: {
                                      open: _vm.openCountry.includes(
                                        country.name
                                      )
                                    },
                                    attrs: { id: country.id }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "link-country",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.showCountry(country.name)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "container" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "heading-country"
                                                  },
                                                  [
                                                    country.emoji.length
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              country.emoji
                                                            )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(
                                                      " \n                        " +
                                                        _vm._s(country.name) +
                                                        " ("
                                                    ),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          country.tj.length +
                                                            country.jk.length
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(
                                                      ")\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "open-indicator",
                                                    class: {
                                                      open: _vm.openCountry.includes(
                                                        country.name
                                                      )
                                                    }
                                                  },
                                                  [_vm._v("+")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "list-fellows-wrapper",
                                    class: {
                                      open: _vm.openCountry.includes(
                                        country.name
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "container" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "btn btn-view-toggle",
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.showMap($event)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "24px",
                                                  height: "24px",
                                                  viewBox: "0 0 24 24",
                                                  fill: "currentColor"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M7 5.5c0-.27614237.22385763-.5.5-.5.27614237 0 .5.22385763.5.5v16c0 .2761424-.22385763.5-.5.5-.27614237 0-.5-.2238576-.5-.5v-16zm8 5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V.5c0-.27614237.2238576-.5.5-.5s.5.22385763.5.5v10zM7.49999031 20.8855413l5.70937779-4.0783989c.2247012-.1605116.5369779-.1084756.6974895.1162257.1605116.2247012.1084756.5369779-.1162257.6974895l-5.99999997 4.286c-.17384956.1241865-.40739755.1241902-.58125103.0000091l-7-5C.07798284 16.813011 0 16.6614756 0 16.5V.5C0 .09331372.45968486-.14324833.7906191.09313326L7.5 4.8855482 14.2093809.09313326c.1738488-.12417768.4073894-.12417768.5812382 0l7 5C21.9220172 5.18698902 22 5.33852445 22 5.5v5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5V5.75730895L14.5 1.1144518 7.7906191 5.90686674c-.17384876.12417768-.40738944.12417768-.5812382 0L1 1.47159466V16.2426911l6.49999031 4.6428502z"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M19.7298535 22.410526c.4626931-.5967776.9253539-1.2275809 1.3563917-1.8628768.3161119-.4659093.6030907-.916805.8540592-1.3459888C22.6214635 18.0368031 23 17.0909932 23 16.5c0-1.9328576-1.5671424-3.5-3.5-3.5-1.9334929 0-3.5 1.5667776-3.5 3.5 0 .5909932.3785365 1.5368031 1.0596956 2.7016604.2509685.4291838.5379473.8800795.8540592 1.3459888.4310378.6352959.8936986 1.2660992 1.3563917 1.8628768.0823909.1062672.1592832.2044439.2298535.2937687.0705703-.0893248.1474626-.1875015.2298535-.2937687zM24 16.5c0 .8207223-.4307758 1.8970571-1.1964523 3.2064484-.2630218.4497965-.5618093.9192456-.8897929 1.4026524-.4439622.6543447-.9188014 1.3017524-1.3936083 1.9141544-.1662019.2143658-.3206346.4091782-.4594125.5808737-.0837463.1036107-.1440169.1769093-.176919.2163178-.1998785.2394044-.5677515.2394044-.76763 0-.0329021-.0394085-.0931727-.1127071-.176919-.2163178-.1387779-.1716955-.2932106-.3665079-.4594125-.5808737-.4748069-.612402-.9496461-1.2598097-1.3936083-1.9141544-.3279836-.4834068-.6267711-.9528559-.8897929-1.4026524C15.4307758 18.3970571 15 17.3207223 15 16.5c0-2.4854685 2.0141837-4.5 4.5-4.5 2.4851424 0 4.5 2.0148576 4.5 4.5z"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M19.5 18.5c-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2 2 .8954305 2 2-.8954305 2-2 2zm0-1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1-1 .4477153-1 1 .4477153 1 1 1z"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h4",
                                          { staticClass: "fellows-heading" },
                                          [
                                            _c("small", [
                                              _c(
                                                "span",
                                                { staticClass: "font-heavy" },
                                                [
                                                  _vm._v(
                                                    _vm._s(country.tj.length)
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " THOMAS J. WATSON FELLOW"
                                              ),
                                              country.tj.length != 1
                                                ? _c("span", [_vm._v("S")])
                                                : _vm._e()
                                            ]),
                                            _vm._v(" "),
                                            country.jk.length > 0
                                              ? _c("small", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "font-heavy"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          country.jk.length
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " JEANNETTE K. WATSON FELLOW"
                                                  ),
                                                  country.jk.length != 1
                                                    ? _c("span", [_vm._v("S")])
                                                    : _vm._e()
                                                ])
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        country.jk.length
                                          ? [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "heading-fellow-type"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      JEANNETTE K. WATSON FELLOW"
                                                  ),
                                                  country.jk.length != 1
                                                    ? _c("span", [_vm._v("S")])
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "list-unstyled list-fellows"
                                                },
                                                _vm._l(
                                                  _vm.alumniByCountry(
                                                    country,
                                                    "jk"
                                                  ),
                                                  function(fellow) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: fellow.Id,
                                                        staticClass: "fellow"
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to:
                                                                "/WAT50N/map/list/" +
                                                                fellow.Id
                                                            }
                                                          },
                                                          [
                                                            _c("h5", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  fellow.FullName__c
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  fellow.Account
                                                                    .Name
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c("h4", [
                                                              _c("small", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    fellow
                                                                      .Master_Year__r
                                                                      .Year__c
                                                                  )
                                                                )
                                                              ])
                                                            ])
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        country.tj.length
                                          ? [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "heading-fellow-type"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      THOMAS J. WATSON FELLOW"
                                                  ),
                                                  country.tj.length != 1
                                                    ? _c("span", [_vm._v("S")])
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "list-unstyled list-fellows"
                                                },
                                                _vm._l(
                                                  _vm.alumniByCountry(
                                                    country,
                                                    "tj"
                                                  ),
                                                  function(fellow) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: fellow.Id,
                                                        staticClass: "fellow"
                                                      },
                                                      [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to:
                                                                "/WAT50N/map/list/" +
                                                                fellow.Id
                                                            }
                                                          },
                                                          [
                                                            _c("h5", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  fellow.FullName__c
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  fellow.Account
                                                                    .Name
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c("h4", [
                                                              _c("small", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    fellow
                                                                      .Master_Year__r
                                                                      .Year__c
                                                                  )
                                                                )
                                                              ])
                                                            ])
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  )
                ])
              : _vm._e()
          ])
        })
      ),
      _vm._v(" "),
      _c("router-view", {
        attrs: { continents: _vm.continents, filter: _vm.filter }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60aea468", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60aea468","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/alumni-list.vue
// module id = 384
// module chunks = 0